import { Star } from "lucide-react";
import { TRUST, EXTERNAL } from "../../lib/site";

const Divider = () => <div className="hidden sm:block h-12 w-px bg-slate-200" />;

export const TrustBar = () => (
  <section className="bg-white border-b border-slate-100 py-9" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-6 md:px-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
      <div className="flex items-center gap-3">
        <div className="text-sm leading-tight">
          <p className="font-display font-black text-2xl text-[#0b192c]">20+</p>
          <p className="text-slate-500">Years of experience</p>
        </div>
      </div>
      <Divider />
      <a href={EXTERNAL.bbb} target="_blank" rel="noopener noreferrer" className="flex items-center hover:opacity-80 transition-opacity" data-testid="trust-bbb">
        <img src={TRUST.bbb} alt="BBB A+ Rating — Accredited Business" className="h-11 object-contain rounded" />
      </a>
      <Divider />
      <a href={EXTERNAL.google} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-testid="trust-google">
        <div className="flex">
          {[0, 1, 2, 3, 4].map((i) => (
            <Star key={i} className="w-4 h-4 fill-[#f5b301] text-[#f5b301]" />
          ))}
        </div>
        <div className="text-sm leading-tight">
          <p className="font-semibold text-[#0b192c]">4.9 · Google &amp; Yelp</p>
          <p className="text-slate-500">Trusted by travelers</p>
        </div>
      </a>
      <Divider />
      <div className="text-sm leading-tight max-w-xs">
        <p className="font-semibold text-[#0b192c]">Private courier service</p>
        <p className="text-slate-500">Not a government agency; not affiliated with or endorsed by the U.S. government.</p>
      </div>
    </div>
  </section>
);
